import { render } from "./CustomerProfileEditView.vue?vue&type=template&id=841d01fc&scoped=true&ts=true&lang=pug"
import script from "./CustomerProfileEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerProfileEditView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerProfileEditView.vue?vue&type=style&index=0&id=841d01fc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-841d01fc"]])

export default __exports__